export default "__VITE_PUBLIC_ASSET__98c2dd3e__"